var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import ButtonLogin from './ButtonLogin';
var GoogleLogo = require('src/assets/img/google.svg');
var selfStyles = require('./ButtonLogin.scss');
var ButtonLoginGoogle = (function (_super) {
    __extends(ButtonLoginGoogle, _super);
    function ButtonLoginGoogle(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
        };
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    ButtonLoginGoogle.prototype.componentWillUnmount = function () {
        if (this.popupTimer) {
            window.clearInterval(this.popupTimer);
        }
        if (this.popupWindow) {
            this.popupWindow.close();
        }
    };
    ButtonLoginGoogle.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.isAuthenticated) {
            this.props.navigateToNext();
        }
    };
    ButtonLoginGoogle.prototype.handleClick = function () {
        var _this = this;
        this.props.handleBlockOtherLoginMethods(true);
        this.setState({ isFetching: true });
        this.popupWindow = window.open(process.env.SERVER_MAIN_URL + "/auth/google", 'Google Authentication', 'width=420,height=500');
        this.popupTimer = window.setInterval(function () {
            if (_this.popupWindow && _this.popupWindow.closed) {
                _this.props.handleBlockOtherLoginMethods(false);
                _this.setState({ isFetching: false });
                window.clearInterval(_this.popupTimer);
            }
        }, 200);
    };
    ButtonLoginGoogle.prototype.render = function () {
        return (React.createElement(ButtonLogin, { isDisabled: this.props.isDisabled, isFetching: this.state.isFetching },
            React.createElement("button", { className: selfStyles.google, onClick: this.handleClick },
                React.createElement("img", { src: GoogleLogo }),
                "Continue with Google")));
    };
    ButtonLoginGoogle.defaultProps = {
        isDisabled: false,
        isAuthenticated: false,
        navigateToNext: function () { },
        handleBlockOtherLoginMethods: function () { },
    };
    return ButtonLoginGoogle;
}(React.Component));
var mapStateToProps = function (state) { return ({
    isAuthenticated: state.auth.isSignedIn,
}); };
export default connect(mapStateToProps)(ButtonLoginGoogle);



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/Authentication/ButtonLoginGoogle.tsx
// module id = 721
// module chunks = 0